module.exports = __webpack_public_path__ + "img/top1.30848963.png";